<script setup lang="ts">
import { views as Views } from '@evac/dashboard'
import { Upload } from '@evac/shared'

const { path } = Upload.usePlanImage()
</script>

<template>
  <Views.Basic>
    <template v-if="path" #image>
      <div class="container-type-size">
        <img :src="path" alt="Floor plan" class="rounded-xl shadow-md aspect-349/166 h-full mx-auto object-cover" />
      </div>
    </template>
  </Views.Basic>
</template>
